// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1jF4G","header":"ReportDetails_header__1ARtt","title":"ReportDetails_title__4RuwU","left":"ReportDetails_left__1Iuxx"};